var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"id":"footer-copyright"}},[_c('div',{staticClass:"container font-subtitle-3",class:{'completion-timer-space':_vm.addCompletionBtnSpace},attrs:{"id":"copyright"}},[_vm._v(" © "+_vm._s(_vm.fullYear)+" Sekolah.mu All Rights Reserved ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }